module.exports = __webpack_public_path__ + "img/pennellata-dritta.c4273219.jpg";